// extracted by mini-css-extract-plugin
module.exports = {"h1":"HeaderLogo_SP_h1__dCn_w","logo":"HeaderLogo_SP_logo__2gL94","label":"HeaderLogo_SP_label__rmRJr"};